import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-23f635dc")

_pushScopeId("data-v-23f635dc")
const _hoisted_1 = { class: "flex w-full flex-col gap-y-3" }
const _hoisted_2 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_3 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_5 = { class: "flex w-full flex-col gap-1" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "text-12px font-semibold text-black-lp-100" }
const _hoisted_8 = { class: "flex items-center gap-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Geolocation = _resolveComponent("Geolocation")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode(_component_ModalV2, {
      class: "pickup-address-form-modal",
      title: _ctx.modalTitle,
      onClose: _ctx.onClose,
      width: "pickup-address-modal-width",
      showFooter: false,
      titlePadding: "px-4 py-4",
      contentPadding: "px-4 py-4",
      marginHeader: "mb-0",
      "data-testid": "pickup-address-form-modal"
    }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "w-full pickup-address-field",
            label: _ctx.$t('pickupAddress.form.addressName'),
            fontSize: 12
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.addressName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addressName = $event)),
                placeholder: _ctx.$t('pickupAddress.form.addressNamePlaceholder'),
                "max-length": 30
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "w-full pickup-address-field",
            label: _ctx.$t('pickupAddress.form.picName'),
            fontSize: 12
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.picName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.picName = $event)),
                placeholder: _ctx.$t('pickupAddress.form.picNamePlaceholder'),
                "max-length": 100
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              class: "w-full pickup-address-field",
              label: _ctx.$t('pickupAddress.form.phoneNumber'),
              fontSize: 12
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "PhoneNumber",
                  error: _ctx.phoneNumberError,
                  phone: _ctx.phoneNumber,
                  code: _ctx.phoneNumberCode,
                  onSetPhone: _ctx.setPhoneNumber,
                  onSetPhoneCode: _ctx.setPhoneCodeNumber,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneNumberCode,
                  showChevron: true
                }, null, 8, ["error", "phone", "code", "onSetPhone", "onSetPhoneCode", "onSetErrorPhoneCode"])
              ]),
              _: 1
            }, 8, ["label"]),
            _withDirectives(_createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberError.message), 1)
            ], 512), [
              [_vShow, _ctx.phoneNumberError.success && _ctx.phoneNumberError.message]
            ])
          ]),
          _createVNode(_component_DataWrapper, {
            class: "w-full pickup-address-field",
            label: _ctx.$t('pickupAddress.form.district'),
            fontSize: 12
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-2",
                options: _ctx.districtOptions,
                placeholder: _ctx.$t('pickupAddress.form.districtPlaceholder'),
                modelValue: _ctx.districtId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.districtId = $event)),
                "is-loading": _ctx.locationController.isLoadingDistrict,
                "is-server-side": true,
                "key-value": "name",
                onFocus: _ctx.onFocusDistricts,
                onFilter: _ctx.onSearchDistricts,
                onChange: _ctx.onSelectDistrict
              }, null, 8, ["options", "placeholder", "modelValue", "is-loading", "onFocus", "onFilter", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "w-full pickup-address-field",
            label: _ctx.$t('pickupAddress.form.pickupAddress'),
            fontSize: 12
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.address,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address = $event)),
                placeholder: _ctx.$t('pickupAddress.form.pickupAddressPlaceholder'),
                type: "textarea",
                "text-area-rows": "2",
                "max-length": 255,
                "show-max-length": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("pickupAddress.form.coordinates")), 1),
              _createVNode(_component_Geolocation, {
                isOpen: _ctx.isGeolocationOpen,
                onVisibilityChange: _ctx.onGeolocationVisibilityChange
              }, null, 8, ["isOpen", "onVisibilityChange"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.geoloc,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.geoloc = $event)),
                class: "flex-grow",
                placeholder: _ctx.$t('pickupAddress.form.coordinatesPlaceholder'),
                "max-length": 255
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_LpButton, {
                title: _ctx.$t('pickupAddress.form.findLocation'),
                "data-testid": "pickup-address-form-button-cari-titik",
                textColor: "black-lp-100",
                color: "gray-lp-600",
                iconLeft: "location-pin",
                iconV2: "",
                sizeIcon: "w-4",
                customClass: "h-10",
                small: "",
                outline: "",
                onClick: _ctx.openGoogleMaps
              }, null, 8, ["title", "onClick"])
            ])
          ]),
          _createVNode(_component_CheckboxV2, {
            value: _ctx.isDefault,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDefault = $event)),
            disabled: _ctx.isCheckboxDefaultDisabled,
            label: _ctx.$t('pickupAddress.form.setPrimary'),
            keyName: "pickup-address-form-checkbox-primary",
            textSize: 14,
            labelWeight: "normal",
            className: "pickup-address-checkbox flex items-center"
          }, null, 8, ["value", "disabled", "label"]),
          _createVNode(_component_button_fill, {
            title: _ctx.$t('pickupAddress.form.submit'),
            "data-testid": "pickup-address-form-button-submit",
            custom: "w-full bg-red-lp-2400 border-red-lp-2400 px-8",
            "is-disabled": _ctx.disableButtonSave,
            onClick: _cache[7] || (_cache[7] = 
            () => {
              _ctx.saveAddress();
            }
          )
          }, null, 8, ["title", "is-disabled"])
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]), [
      [_vShow, !_ctx.isGeolocationOpen && !_ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSuccessAddAddress,
      onClose: _ctx.onSuccessAddAddress,
      title: _ctx.successTitle,
      message: _ctx.$t('pickupAddress.success.message'),
      image: "image-modal-success",
      textSuccess: _ctx.$t('pickupAddress.success.button'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ]))
})